var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChildstepicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8906 11.8525C16.6115 12.2168 16.1819 12.4344 15.7231 12.4438C15.2653 12.4318 14.837 12.2147 14.5566 11.8525",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4433 11.8525C11.1645 12.2165 10.7353 12.4341 10.2769 12.4438C9.81871 12.4318 9.39014 12.2148 9.10938 11.8525",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 21.3365C16.7545 21.3346 20.0441 18.8224 21.0343 15.2009C22.1561 15.0787 23.0058 14.1314 23.0058 13.003C23.0058 11.8746 22.1561 10.9273 21.0343 10.8051C20.0467 7.18156 16.7557 4.66759 13 4.66759C9.24429 4.66759 5.95334 7.18156 4.96565 10.8051C3.84391 10.9273 2.99419 11.8746 2.99419 13.003C2.99419 14.1314 3.84391 15.0787 4.96565 15.2009C5.95588 18.8224 9.24553 21.3346 13 21.3365Z",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2229 16.0083C13.9493 17.1194 12.0507 17.1194 10.7771 16.0083",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8885 8.189C12.2114 8.42454 12.6003 8.55231 13 8.55415C14.0572 8.53017 14.9017 7.66629 14.9017 6.60884C14.9017 5.55139 14.0572 4.6875 13 4.66353",
    stroke: "#00C49A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildstepicon);
export default __webpack_public_path__ + "static/media/childstepicon.f49c83ff51afb7f5fbebcb598d6ae217.svg";
export { ForwardRef as ReactComponent };